/**
 * EL NOMBRE QUE VA ARRIBA ES EL DEL NEGOCIO (13-oct-2026).
 *
 * Kervens: «a partir de hoy, Conversia no se llama Conversia… allá arriba vas a poner el nombre
 * del negocio del cliente… El de Osito tiene que decir Osito ahí arriba… cambiar el color por
 * rojo, ponlo borde redondo».
 */

/** El negocio de esta instalación, mientras la configuración no ha dicho su nombre. */
export const NEGOCIO = 'Osito';

/** Las iniciales del negocio para su sello: «Osito» → «O». PURO. */
export function inicialesDe(nombre: string): string {
  const palabras = nombre.trim().split(' ').filter(Boolean);
  return (palabras.slice(0, 2).map((p) => p[0]).join('') || '·').toUpperCase();
}
